import { Box, Button, Dialog, DialogContent, Divider, Grid, Typography } from '@mui/material'
import React from 'react'

const Confirmation = ({open,setOpen,msg,yesClick}) => {
    return (
        <Dialog
            open={open}
            onClose={() => { setOpen(false) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <Grid item size={{ lg: 3, md: 6, sm: 12, xs: 12 }}>
                    <Box>
                        <Typography variant="h6" gutterBottom>
                            Confirmation
                        </Typography>
                        <Divider />
                        <Typography variant="body1" className='mt-3' gutterBottom>
                            {msg} ?
                        </Typography>
                    </Box>
                </Grid>
                <Box display="flex" justifyContent="center" mt={3} gap={1}>
                    <Button onClick={()=>{setOpen(false)}} variant="outlined" color='primary' >No</Button>
                    <Button onClick={yesClick} variant="contained" color='primary' type="submit">
                        Yes
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>)
}

export default Confirmation